import { apiCall } from 'store/services/service';
import { URL_NEWS, URL_NEWS_DETAIL, URL_NEWS_RECENT } from 'store/services/URL';
import { NewsItem, NewsDetail } from 'views/news/newsTypes';

export interface FetchNewsResult {
  news: NewsItem[];
  hasMore: boolean;
  unreadCount: number;
}

/** Fetch a batch: GET /news?offset=&limit= -> { news, hasMore } */
export async function fetchNewsBatch(
  offset: number,
  limit: number,
): Promise<FetchNewsResult> {
  const res: any = await apiCall.get({
    url: `${URL_NEWS}?offset=${offset}&limit=${limit}`,
    isAuthToken: true,
    params: {},
  });

  if (res && Array.isArray(res.news)) {
    return { news: res.news, hasMore: !!res.hasMore, unreadCount: res.unreadCount || 0 };
  }
  return { news: [], hasMore: false, unreadCount: 0 };
}

/** Fetch a single article: GET /news/<id> */
export async function fetchNewsById(id: number | string): Promise<NewsDetail | null> {
  const res: any = await apiCall.get({
    url: `${URL_NEWS_DETAIL}${id}`,
    isAuthToken: true,
    params: {},
  });

  if (res && res.id) {
    return res as NewsDetail;
  }
  return null;
}

/** Recent items for the detail-page sidebar: GET /news/recent?limit=&exclude= */
export async function fetchRecentNews(
  limit = 4,
  exclude?: number | string,
): Promise<NewsItem[]> {
  const query = exclude ? `?limit=${limit}&exclude=${exclude}` : `?limit=${limit}`;
  const res: any = await apiCall.get({
    url: `${URL_NEWS_RECENT}${query}`,
    isAuthToken: true,
    params: {},
  });

  if (res && Array.isArray(res.news)) {
    return res.news;
  }
  return [];
}
